import { Component, OnInit, Input } from '@angular/core';

import { MarvColor } from '@marv/types';

@Component({
    selector: 'marv-circle',
    templateUrl: './circle.component.html',
    styleUrls: ['./circle.component.scss'],
})
export class MarvCircleComponent  implements OnInit {

    @Input({alias : 'color', required : false}) colorCircle: MarvColor;
    @Input({alias : 'size', required : false}) sizeCircle: 'normal'|'small' = 'normal';
    
    constructor() { }

    ngOnInit() {}

}
